import React, { memo } from 'react';
import { receptionParticipantTableHeader as headers } from '../config';
import { TableRow, TableCell, TableText } from '@/shared/components/molecules/table.style';
import { formatDate } from '@shared/utils/common';
import ReceiveStatusBadge from './ReceiveStatusBadge';
import MethodBadge from './MethodBadge';
import type { ReceptionParticipantItemDto } from '@/api/generated/model';

type ReceptionParticipantItemProps = {
	participant: ReceptionParticipantItemDto; // phoneNumber는 서버에서 maskPhone 파라미터에 따라 마스킹되어 내려옴
	onSelect: (participant: ReceptionParticipantItemDto) => void;
};

// 리셉션 상세 - 참가자 명단 행
const ReceptionParticipantItem = memo<ReceptionParticipantItemProps>(({ participant, onSelect }) => {
	return (
		<TableRow onClick={() => onSelect(participant)}>
			<TableCell $minWidth={headers[0].minWidth} $width={headers[0].width}>
				<TableText>{participant.bibNumber ?? '-'}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[1].minWidth} $width={headers[1].width}>
				<TableText>{participant.name}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[2].minWidth} $width={headers[2].width}>
				<TableText>{participant.course}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[3].minWidth} $width={headers[3].width}>
				<TableText>{participant.phoneNumber}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[4].minWidth} $width={headers[4].width}>
				<TableText>{formatDate(participant.birthDate ?? undefined, 'YYYY.MM.DD')}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[5].minWidth} $width={headers[5].width}>
				<TableText>
					<ReceiveStatusBadge status={participant.status === 'checked' ? 'RECEIVED' : 'NOT_RECEIVED'} />
				</TableText>
			</TableCell>
			<TableCell $minWidth={headers[6].minWidth} $width={headers[6].width}>
				<TableText>{formatDate(participant.checkinTime ?? undefined, 'YY.MM.DD HH:mm')}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[7].minWidth} $width={headers[7].width}>
				<TableText>{participant.manager || '-'}</TableText>
			</TableCell>
			<TableCell $minWidth={headers[8].minWidth} $width={headers[8].width}>
				<TableText>{participant.type ? <MethodBadge method={participant.type} /> : '-'}</TableText>
			</TableCell>
		</TableRow>
	);
});

ReceptionParticipantItem.displayName = 'ReceptionParticipantItem';

export default ReceptionParticipantItem;
